import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import services from '../../../services';
import ContactData from './ContactData';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
  white: {
    // paddingLeft: '15px',
    paddingRight: '15px',
    ['@media(min-width:1024px)']: {
      whiteSpace: 'nowrap',
    },
    ['@media(min-width:768px)']: {
      paddingLeft: '15px',
    },
  },
});
function ServiceOptions() {
  const classes = useStyles();
  const { t } = useTranslation();
  let history = useHistory();
  function goToService(service) {
    const url = `/service?id=${service.id}`;
    history.push(url);
  }
  return (
    <>
      <Grid
        className="service-options-container options-container"
        // style={{
        //   marginRight: '0px',
        //   marginLeft: '0x',
        //   display: 'flex',
        //   paddingLeft: '15px',
        //   paddingRight: '15px',
        // }}
      >
        <Grid items xs={6} className="options-container-left">
          <h1>{t('sections-NavBar-ServiceOptions-heading')}</h1>
          <p>
            {t('sections-NavBar-ServiceOptions-headingDesc')}
            <br />
            {t('sections-NavBar-ServiceOptions-headingDescCont')}
          </p>

          <div>
            <a href={`tel:${ContactData.phone}`} rel="noopener noreferrer">
              <i
                className="bx bxs-phone-call"
                style={{ cursor: 'pointer' }}
              ></i>
            </a>
            {/* <Link
              to={{
                pathname: window.matchMedia('(max-width: 786px)').matches
                  ? `mailto:${ContactData.mail}`
                  : `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${ContactData.mail}`,
                state: { fromDashboard: true },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i
                className="bx bxs-envelope"
                style={{ cursor: 'pointer', marginLeft: '16px' }}
              ></i>
            </Link> */}
          </div>
        </Grid>

        <Grid items xs={6} className="options-container-right">
          <Grid container>
            {services.map((service, i) => {
              return (
                <Grid
                  items
                  xs={4}
                  className={`option ${classes.white}`}
                  key={i}
                  onClick={() => goToService(service)}
                >
                  {service.title}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ServiceOptions;
